import React, { useState, useEffect } from 'react';
import { MR_SQUARE_MARK_URL } from '@/lib/brandMark';

/**
 * Slim, non-interactive header for the wall-mounted venue displays.
 *
 * Deliberately carries no navigation, no staff name and no controls — a display
 * screen must never offer a way to leave the view it was installed for. Sized
 * for reading from across the venue floor.
 */
export default function VenueDisplayHeader({ title, subtitle }) {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const time = now.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
  const date = now.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });

  return (
    <header className="flex items-center justify-between gap-6 px-6 lg:px-10 py-5 border-b border-white/10 bg-[#0d0d0f] shrink-0">
      <div className="flex items-center gap-4 min-w-0">
        <img src={MR_SQUARE_MARK_URL} alt="Motion Reality" className="h-12 w-12 shrink-0" />
        <span className="hidden sm:block w-px h-8 bg-white/10" />
        <div className="min-w-0">
          <h1 className="text-white font-black text-xl md:text-3xl uppercase tracking-tight leading-none truncate">
            {title}
          </h1>
          <p className="text-white/40 text-[11px] font-bold tracking-[0.2em] mt-2 flex items-center gap-2 uppercase">
            <span className="relative flex w-2 h-2 shrink-0">
              <span className="absolute inline-flex w-full h-full rounded-full bg-primary animate-ping" />
              <span className="relative inline-flex w-2 h-2 rounded-full bg-primary" />
            </span>
            {subtitle}
          </p>
        </div>
      </div>

      <div className="text-right shrink-0">
        <p className="text-white font-mono font-black text-2xl md:text-3xl leading-none tabular-nums">{time}</p>
        <p className="text-white/40 text-[10px] font-bold tracking-widest mt-1.5 uppercase">{date}</p>
      </div>
    </header>
  );
}